import React from 'react';
import { useLingui } from '@lingui/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FieldProgress = _ref => {
  let {
    progressType = 'pie',
    wrapperClass = ''
  } = _ref;
  const {
    i18n
  } = useLingui();
  const subtext = i18n._('carlead.progress.subtext');
  return /*#__PURE__*/_jsxs("div", {
    className: `progress ${progressType} ${wrapperClass}`,
    "data-tracking": true,
    "data-action": "Click",
    "data-category": "Lead",
    "data-label": `progress ${progressType}`,
    children: [/*#__PURE__*/_jsx("div", {
      className: `progress--${progressType}`,
      children: /*#__PURE__*/_jsx("div", {
        className: "progress--overlay"
      })
    }), subtext && /*#__PURE__*/_jsx("p", {
      className: "progress__subtext",
      children: subtext
    })]
  });
};
export default FieldProgress;